import { variableValidator } from './common'

const regExp = new RegExp('</?.*?>', 'g')
export default variableValidator(regExp)
